<template>
  <div>
    <div class="page-header dashboard-header">
      <div>
        <div class="page-title">支付通道管理系统</div>
        <div class="page-subtitle">总后台 · 运营管理总览</div>
      </div>

    </div>

    <el-card class="dashboard-hero">
      <div class="hero-content">
        <div class="hero-main">
          <div class="hero-title">今日成功收款</div>
          <div class="hero-value">￥{{ formatMoney(dashboardData.today_total) }}</div>
          <div class="hero-meta">支付成功率 {{ dashboardData.today_success_rate }} · 累计收款 ￥{{ formatMoney(dashboardData.total_amount) }}</div>
        </div>
        <div class="hero-tags">
          <el-tag type="success" effect="dark">系统正常</el-tag>
          <!-- <el-tag type="info" effect="dark">高峰期提醒</el-tag> -->
        </div>
      </div>
    </el-card>

    <el-row :gutter="16" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat">
            <div class="stat-label">今日收款金额</div>
            <div class="stat-value">￥{{ formatMoney(dashboardData.today_total) }}</div>
            <div class="stat-meta">成功率 {{ dashboardData.today_success_rate }}</div>
          </div>
          <div class="stat-icon stat-icon-gold">
            <i class="el-icon-money"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat">
            <div class="stat-label">活跃商户</div>
            <div class="stat-value">{{ merchantTotal }}</div>
            <div class="stat-meta">本周新增 {{ merchantWeekNew }}</div>
          </div>
          <div class="stat-icon stat-icon-blue">
            <i class="el-icon-s-custom"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat">
            <div class="stat-label">进件审核中</div>
            <div class="stat-value">{{ merchantPending }}</div>
            <div class="stat-meta">已通过{{ merchantApproved }}个</div>
          </div>
          <div class="stat-icon stat-icon-purple">
            <i class="el-icon-document-checked"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat">
            <div class="stat-label">进件审核失败</div>
            <div class="stat-value">{{ merchantFailed }}</div>
            <div class="stat-meta">需要复核</div>
          </div>
          <div class="stat-icon stat-icon-red">
            <i class="el-icon-warning"></i>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" type="flex" class="report-row">
      <el-col :span="24">
        <el-card class="report-card">
          <div slot="header" class="card-header">
            <span>交易趋势（近 7 日）</span>
            <el-tag size="mini" type="success">实时</el-tag>
          </div>
          <div class="trend-bars">
            <div class="trend-item" v-for="item in trend" :key="item.day" :title="`${item.day}: ￥${formatMoney(item.amount)}`">
              <div class="trend-bar" :style="{ height: item.value + '%' }"></div>
              <div class="trend-label"> ￥{{ formatMoney(item.amount) }}</div>
               <div class="trend-label">{{ item.day }} </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <!-- <el-col :span="8">
        <el-card class="report-card">
          <div slot="header" class="card-header">
            <span>通道占比</span>
            <el-tag size="mini" type="info">本周</el-tag>
          </div>
          <div class="ratio-list">
            <div class="ratio-item" v-for="item in ratios" :key="item.name">
              <div class="ratio-info">
                <span>{{ item.name }}</span>
                <span class="ratio-value">{{ item.value }}%</span>
              </div>
              <div class="ratio-bar">
                <span class="ratio-bar-fill" :style="{ width: item.value + '%' }"></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col> -->
    </el-row>

    <!-- <el-card class="list-card">
      <div slot="header" class="card-header">
        <span>通道概览</span>
        <el-button type="text">查看全部</el-button>
      </div>
      <el-table :data="channels" stripe>
        <el-table-column prop="name" label="通道名称" min-width="160" />
        <el-table-column prop="type" label="通道类型" width="120" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column prop="updatedAt" label="最近更新" width="160" />
      </el-table>
    </el-card> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      merchantTotal: 0,
      merchantWeekNew: 0,
      merchantPending: 0,
      merchantApproved: 0,
      merchantFailed: 0,
      dashboardData: {
        today_total: 0,
        today_success_rate: '0%',
        total_amount: 0,
        total_success_rate: '0%'
      },
      channels: [
        // {
        //   name: "银联快捷",
        //   type: "银行卡",
        //   rate: "0.38%",
        //   status: "启用",
        //   updatedAt: "2024-05-12 09:30"
        // },
        {
          name: "微信支付",
          type: "h5",
          rate: "0.50%",
          status: "启用",
          updatedAt: "2024-05-12 10:20"
        },
        {
          name: "支付宝",
          type: "h5",
          rate: "0.45%",
          status: "维护",
          updatedAt: "2024-05-11 18:10"
        },
        // {
        //   name: "聚合通道",
        //   type: "聚合",
        //   rate: "0.42%",
        //   status: "启用",
        //   updatedAt: "2024-05-11 14:52"
        // }
      ],
      trend: [
        { day: "周一", value: 45 },
        { day: "周二", value: 60 },
        { day: "周三", value: 72 },
        { day: "周四", value: 58 },
        { day: "周五", value: 80 },
        { day: "周六", value: 64 },
        { day: "周日", value: 52 }
      ],
      ratios: [
        { name: "微信支付", value: 42 },
        { name: "支付宝", value: 33 },

      ]
    };
  },
  computed: {},
  mounted() { },
  created() {
    // 初始化拉取商户统计
    this.getMerchantStats();
    // 初始化拉取仪表盘数据
    this.getDashboard();
  },
  methods: {
    // 获取商户统计
    getMerchantStats() {
      this.$http_get("/admin/merchant/list?page=1&limit=50", 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.merchantTotal = Number(res.data.total || 0);
          this.merchantWeekNew = this.countWeekNew(list);
        }
      });
    },
    // 获取仪表盘数据
    getDashboard() {
      this.$http_get("/admin/home/index", 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.dashboardData = res.data;
          if (res.data.trend && res.data.trend.length > 0) {
            this.trend = res.data.trend;
          }
          this.merchantPending = res.data.merchant_pending || 0;
          this.merchantApproved = res.data.merchant_approved || 0;
          this.merchantFailed = res.data.merchant_failed || 0;
        }
      });
    },
    // 统计近7天新增数量
    countWeekNew(list) {
      const now = Date.now();
      const weekAgo = now - 7 * 24 * 60 * 60 * 1000;
      let count = 0;
      list.forEach(item => {
        const ts = this.parseTimestamp(item.created_at);
        if (ts >= weekAgo) {
          count += 1;
        }
      });
      return count;
    },
    // 解析时间戳
    parseTimestamp(value) {
      if (!value) {
        return 0;
      }
      const numeric = Number(value);
      if (!Number.isNaN(numeric)) {
        return numeric * 1000;
      }
      const ts = Date.parse(value);
      return Number.isNaN(ts) ? 0 : ts;
    },
    // 格式化金额
    formatMoney(value) {
      if (!value && value !== 0) {
        return '0.00';
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style>
.dashboard-header {
  align-items: flex-end;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.dashboard-hero {
  margin-bottom: 18px;
  background: linear-gradient(120deg, #0f1b2a, #1f2a44);
  color: #fff;
  border: none;
}

.dashboard-hero .el-card__body {
  padding: 18px 22px;
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.hero-title {
  font-size: 14px;
  opacity: 0.8;
}

.hero-value {
  font-size: 28px;
  font-weight: 600;
  margin: 6px 0;
}

.hero-meta {
  font-size: 12px;
  opacity: 0.7;
}

.hero-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.stat-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}

.stat-card .el-card__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.stat-icon-gold {
  background: #f7c84b;
}

.stat-icon-blue {
  background: #3b82f6;
}

.stat-icon-purple {
  background: #8b5cf6;
}

.stat-icon-red {
  background: #ef4444;
}

.report-row {
  margin-bottom: 18px;
}

.report-row .el-col {
  display: flex;
}

.report-row .el-card {
  width: 100%;
}

.report-card {
  border-radius: 12px;
}

.trend-bars {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 180px;
  padding: 10px 6px 0;
}

.trend-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  height: 100%;
}

.trend-bar {
  width: 100%;
  min-height: 8px;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, #60a5fa, #1d4ed8);
}

.trend-label {
  font-size: 12px;
  color: #6b7280;
}

.ratio-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ratio-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ratio-info {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #374151;
}

.ratio-value {
  font-weight: 600;
}

.ratio-bar {
  height: 8px;
  background: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.ratio-bar-fill {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #f97316);
}
</style>
